import { RootState } from "@/store/store";
import { resourceExplorerChartSettingsSelector } from "@/store/resource-explorer/selectors/current-resource-explorer/chart/settings/resourceExplorerChartSettingsSelector";
import { chartTypeToHighchartsChartType } from "@/store/resource-explorer/utils/helpers/chart/chartTypeToHighchartsChartType";
import { HighchartsChartType } from "@/storybook/c8r-highcharts/common/components/HighchartsChartTypeSelect";

export const billingExplorerChartTypeSelector = (
  state: RootState,
): HighchartsChartType => {
  const data = resourceExplorerChartSettingsSelector(state);

  return chartTypeToHighchartsChartType(data?.chart_type ?? "stacked_column");
};
